"use client";

import { usePostHog } from "posthog-js/react";
import { useEffect } from "react";
import { Logo } from "~/components/logo";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const posthog = usePostHog();

  useEffect(() => {
    posthog.captureException(error);
  }, [error, posthog]);

  return (
    // global-error must include html and body tags
    <html>
      <body>
        <div className="relative min-h-screen bg-black text-white">
          <Logo className="absolute left-4 top-4" fill="#fff" />
          <div className="flex min-h-screen flex-col items-center justify-center px-4">
            <h1 className="mb-4 text-6xl font-bold">500</h1>
            <h2 className="mb-6 text-2xl font-semibold">
              ¡Ups! Error del servidor
            </h2>
            <p className="mb-4 max-w-md text-center text-lg">
              Ha ocurrido un error en nuestros servidores.
            </p>

            <button
              onClick={() => reset()}
              className="rounded border border-white px-6 py-2 text-sm font-medium text-white transition-colors hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black"
            >
              Intentar de nuevo
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}
